module.exports = {"pathContext":{"slug":"/en/Catalog/Kodak/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en-catalog-kodak.json
// module id = 1266
// module chunks = 17475807462898